<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import AiMarkdown from '@/nonfree/ai/AiMarkdown.vue'

import type { Block } from './block'

defineProps<{ block: Block<'text'> }>()
</script>

<template>
  <AiMarkdown class="ai-block-answer" :text="block.text" />
</template>

<style scoped>
.ai-block-answer {
  width: fit-content;
  padding: var(--dimension-4);
  border-radius: var(--dimension-5);
  background-color: color-mix(in srgb, var(--border-color-purple) 12%, transparent);
}
</style>
